package com.wintermar.inspection.core.ui.component.badge.variant

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

sealed class BadgePaletteVariant {
    @Composable
    abstract fun palette(): BadgeColorModel

    @Composable
    protected fun defaultStrongPalette(): BadgePaletteModel {
        val color = LocalAppTheme.current.color
        return BadgePaletteModel(
            textColor = color.text.inverse,
            iconColor = color.icon.inverse,
        )
    }

    object Gray : BadgePaletteVariant() {
        @Composable
        override fun palette(): BadgeColorModel {
            val color = LocalAppTheme.current.color
            return BadgeColorModel(
                default = BadgePaletteModel(
                    backgroundColor = color.surface.neutral.subtle.default,
                    textColor = color.text.subtle,
                    iconColor = color.icon.subtle,
                    borderColor = color.border.default
                ),
                strong = defaultStrongPalette().copy(
                    backgroundColor = color.surface.neutral.bold.default
                )
            )
        }
    }

    object Blue : BadgePaletteVariant() {
        @Composable
        override fun palette(): BadgeColorModel {
            val color = LocalAppTheme.current.color
            return BadgeColorModel(
                default = BadgePaletteModel(
                    backgroundColor = color.surface.semantic.info.subtle.default,
                    textColor = color.text.info.bolder,
                    iconColor = color.icon.info.bolder,
                    borderColor = color.border.info
                ),
                strong = defaultStrongPalette().copy(
                    backgroundColor = color.surface.semantic.info.bold.default
                )
            )
        }
    }

    object Yellow : BadgePaletteVariant() {
        @Composable
        override fun palette(): BadgeColorModel {
            val color = LocalAppTheme.current.color
            return BadgeColorModel(
                default = BadgePaletteModel(
                    backgroundColor = color.surface.semantic.warning.subtle.default,
                    textColor = color.text.warning.default,
                    iconColor = color.icon.warning.default,
                    borderColor = color.border.warning
                ),
                strong = defaultStrongPalette().copy(
                    backgroundColor = color.surface.semantic.warning.bold.default
                )
            )
        }
    }

    object Green : BadgePaletteVariant() {
        @Composable
        override fun palette(): BadgeColorModel {
            val color = LocalAppTheme.current.color
            return BadgeColorModel(
                default = BadgePaletteModel(
                    backgroundColor = color.surface.semantic.success.subtle.default,
                    textColor = color.text.success.bolder,
                    iconColor = color.icon.success.bolder,
                    borderColor = color.border.success
                ), strong = defaultStrongPalette().copy(
                    backgroundColor = color.surface.semantic.success.bold.default
                )
            )
        }
    }

    object Red : BadgePaletteVariant() {
        @Composable
        override fun palette(): BadgeColorModel {
            val color = LocalAppTheme.current.color
            return BadgeColorModel(
                default = BadgePaletteModel(
                    backgroundColor = color.surface.semantic.error.subtle.default,
                    textColor = color.text.error.bolder,
                    iconColor = color.icon.error.default,
                    borderColor = color.border.error
                ),
                strong = defaultStrongPalette().copy(
                    backgroundColor = color.surface.semantic.error.bold.default
                )
            )
        }
    }

    object GrayGreen : BadgePaletteVariant() {
        @Composable
        override fun palette(): BadgeColorModel {
            val color = LocalAppTheme.current.color
            val contentColor = BadgePaletteModel(
                backgroundColor = color.surface.neutral.subtle.default,
                textColor = color.text.success.bolder,
                iconColor = color.icon.success.bolder,
                borderColor = color.border.default
            )
            return BadgeColorModel(
                default = contentColor,
                strong = contentColor
            )
        }
    }
}
